import React from 'react'
import Homeslider from './Homeslider'
import birdImg from '../images/bird.jpeg'
import boldizar2 from '../images/boldizar2.jpg'
import About from './About'
import Companymember from './Companymember'
import Services from './Services'
// import Googlelocation from './Googlelocation'
const Home = () => {
    return (
        <>
            <Homeslider />
            <div className='container mt-5'>
                <div className='row'>
                    <div className='col-lg-6'>
                        <h4 className='bg-warning'>Be Innovative</h4>
                        <p> Aside from technologies we consider open communication as the key of Innovation. The management is open with new ideas from our team. Any idea that will make good impact and will make procedure better and easier is welcome. We always look forward in hearing new creative ideas that will serve our client's best. We encourage our staff to take initiative in any circumstances. </p>
                        <h4 className='bg-warning'> Safety First</h4>
                        <p>Transportation is a day-by-day operation. Risk is always there. As what they said prevention is better that cure, we put great efforts on keeping every precaution, every rule and every preventive actions strictly followed. Our staff is as important as our clients. In order to carry out an efficient job we need to take good care of our personnel.</p>
                        <h4 className='bg-warning'> Code of Ethics</h4>
                        <p>Overall Early Bird General Transport is guided with the highest ethical standards in the industry. Aside from the quality work we represent our company with a good reputation directed with the following standards:</p>
                        <p> 1. Integrity - We promote honesty and transparency in conduting business</p>
                    </div>
                    {/* col  2 */}
                    <div className='col-lg-6'>
                        <img src={birdImg} alt='' /><hr />
                        <img src={boldizar2} alt='' />
                    </div>
                </div>
                <About /><hr />

            </div>
            {/*  */}
            <hr />
            <Services />
            <hr />


            <Companymember />
        </>
    )
}

export default Home